import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import '../../css/pdf.css';

const VesselParticulars = () => {
    const { statementDocument } = useSelector((state) => state.voyage);
    const { vessel_particulars } = statementDocument || {};

    const columns = [
        { title: 'Voyage No.', dataIndex: 'voyage_no', key: 'voyage_no', align: 'center' },
        { title: 'Vessel Name', dataIndex: 'vessel_name', key: 'vessel_name', align: 'center' },
        { title: 'IMO No.', dataIndex: 'imo_number', key: 'imo_number', align: 'center' },
        { title: 'Vessel Type', dataIndex: 'vessel_type', key: 'vessel_type', align: 'center' },
    ];

    const dataSource = [
        {
            key: '1',
            voyage_no: vessel_particulars?.voyage_no || 'N/A',
            imo_number: vessel_particulars?.imo_number || 'N/A',
            vessel_name: vessel_particulars?.vessel_name || 'N/A',
            vessel_type: vessel_particulars?.vessel_type || 'N/A',
        }
    ];

    const expandedRowRender = () => (
        <>
            <tr className="ant-table-row">
                <td className="period-custom-cell sb-background">Deadweight (T)</td>
                <td className="period-custom-cell sb-background">Gross Tonnage (MT)</td>
                <td className="period-custom-cell sb-background">Cargo Quantity (MT)</td>
                <td className="period-custom-cell sb-background">Ice Class Concession Applicable?</td>
            </tr>
            <tr className="ant-table-row">
                <td className="period-custom-cell ">{vessel_particulars?.summer_dead_weight?.toFixed(2) || 'N/A'}</td>
                <td className="period-custom-cell">{vessel_particulars?.gross_ton?.toFixed(2) || 'N/A'}</td>
                <td className="period-custom-cell ">{vessel_particulars?.total_cargo?.toFixed(2) || 'N/A'}</td>
                <td className="period-custom-cell">{vessel_particulars?.ice_class_concession || 'N/A'}</td>
            </tr>
        </>
    );

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            bordered
            rowClassName={() => 'custom-row'}
            components={{
                header: {
                    wrapper: ({ children, ...props }) => (
                        <thead {...props} className="sb-background">
                            {children}
                        </thead>
                    ),
                },
                body: {
                    wrapper: ({ children, ...props }) => (
                        <tbody {...props}>
                            {children}
                            {expandedRowRender()}
                        </tbody>
                    ),
                },
            }}
        />
    );
}

export default VesselParticulars;
